import { layoutService } from '@/api';

const normalizeQueryRecordRefreshResult = (response) => {
  const result = response?.result || response?.data || response || {};

  if (Array.isArray(result)) {
    return {
      result: {
        records: result
      }
    };
  }

  if (Array.isArray(result?.records)) {
    return {
      result
    };
  }

  if (Array.isArray(result?.data?.records)) {
    return {
      result: result.data
    };
  }

  return {
    result: {
      records: []
    }
  };
};

export const refreshQueryRecordData = async (params = {}) => {
  const requestData = {
    tableEntity: params.tableEntity,
    layoutId: params.layoutId,
    layoutConfigId: params.layoutConfigId,
    businessId: params.businessId || undefined,
    itselfTableEntity: params.itselfTableEntity,
    data: params.data || {}
  };
  const apiIndex = params.apiIndex || `${params.tableEntity || 'query-record'}-${params.layoutConfigId || params.layoutId || 'default'}`;

  const response = await layoutService.getQueryRecordTableData(requestData, apiIndex);
  if (response?.error) {
    const refreshError = new Error(response.error?.msg || 'query record refresh failed');
    refreshError.code = response.error?.code;
    refreshError.responseError = response.error;
    throw refreshError;
  }
  return normalizeQueryRecordRefreshResult(response);
};
